import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient } from "@tanstack/react-query";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import "@/index.css";
import App from "@/App";
import { idbPersister } from "@/lib/persister";

const WEEK = 7 * 24 * 60 * 60 * 1000;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: WEEK,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));

// La rotellina del mouse non deve più cambiare i valori dei campi numerici
// (prezzi, minuti, quantità): scorrendo la pagina il campo perde il fuoco.
document.addEventListener("wheel", (e) => {
  const el = document.activeElement;
  if (el && el.tagName === "INPUT" && el.type === "number" && el === e.target) el.blur();
}, { passive: true });
root.render(
  <React.StrictMode>
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{ persister: idbPersister, maxAge: WEEK, buster: "v1" }}
    >
      <App />
    </PersistQueryClientProvider>
  </React.StrictMode>,
);
